import AbstractBlock from './abstractBlock.js';

export default class RequestSuccessBlock extends AbstractBlock {
    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_request_success');
        if (this.hasElement) {
            console.log('Request Success Block inited');
        } else {
            console.warn('Request Success Block no element');
        }

        this.element
            .on('click', '.js-resend', ::this.resend)
            .on('click', '.js-cancel', ::this.cancel);
    }

    resend() {
        this.events.trigger('resend');
    }

    cancel() {
        this.events.trigger('cancel');
    }
}
